import Link from 'next/link';

import styles from './GDPRCheckbox.module.scss';

export default function GDPRCheckbox({ onClickCheckbox }) {
  return (
    <div className={styles.checkboxGeneralContainer}>
      <div className={styles.checkboxContainer}>
        <input className={styles.checkbox} name="terms" type="checkbox" onChange={onClickCheckbox} />
      </div>
      <p className={styles.checkboxText}>
        {'Αποδέχομαι τους '}
        <Link href="/pages/oroi-xrhshs">
          <a className={styles.link} target="_blank">
            όρους χρήσης
          </a>
        </Link>
        {' της υπηρεσίας '}
        και τη{' '}
        <Link href="/pages/prosopika-dedomena">
          <a className={styles.link} target="_blank">
            Δήλωση Προστασίας Προσωπικών Δεδομένων.
          </a>
        </Link>
      </p>
    </div>
  );
}
